import React from 'react';
import { FiAlertCircle, FiBook, FiCheckCircle, FiCode } from 'react-icons/fi';
import styles from './styles.module.scss';
import { CatalogStats } from './types';

interface StatsGridProps {
    stats: CatalogStats | null;
}

/*
 * Four-tile stats strip showing total endpoints, groups, stable, and beta/deprecated counts.
 */
export function StatsGrid({ stats }: StatsGridProps) {
    const cards = [
        { label: 'Total Endpoints', value: stats?.totalEndpoints ?? 0, Icon: FiCode },
        { label: 'API Groups', value: stats?.totalCategories ?? 0, Icon: FiBook },
        { label: 'Stable', value: stats?.stableCount ?? 0, Icon: FiCheckCircle },
        { label: 'Beta / Deprecated', value: `${stats?.betaCount ?? 0} / ${stats?.deprecatedCount ?? 0}`, Icon: FiAlertCircle },
    ];

    return (
        <div className={styles.statGrid}>
            {cards.map((card) => (
                <div key={card.label} className={styles.statCard}>
                    <div>
                        <p className={styles.statLabel}>{card.label}</p>
                        <p className={styles.statValue}>{card.value}</p>
                    </div>
                    <div className={styles.statIcon}>
                        <card.Icon />
                    </div>
                </div>
            ))}
        </div>
    );
}
